import React, { useState } from 'react';
import { AppShell, Group, Text, Button, Container } from '@mantine/core';
import { IconMountain, IconHome, IconInfoCircle, IconMail, IconLogin } from '@tabler/icons-react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import UserMenu from './UserMenu';
import LoginModal from './LoginModal';

const Navigation = () => {
  const location = useLocation();
  const { user } = useAuth();
  const [loginModalOpened, setLoginModalOpened] = useState(false);

  const NavButton = ({ to, icon, children }) => (
    <Button
      component={Link}
      to={to}
      variant={location.pathname === to ? 'filled' : 'subtle'}
      leftSection={icon}
      color="green"
    >
      {children}
    </Button>
  );

  return (
    <AppShell.Header>
      <Container size="xl">
        <Group justify="space-between" h="100%">
          <Group gap="md">
            <IconMountain size={32} color="var(--mantine-color-green-6)" />
            <Text size="xl" fw={700} c="green">
              WildernessFinder
            </Text>
          </Group>
          
          <Group gap="sm">
            <NavButton to="/" icon={<IconHome size={16} />}>
              Home
            </NavButton>
            <NavButton to="/about" icon={<IconInfoCircle size={16} />}>
              About
            </NavButton>
            <NavButton to="/contact" icon={<IconMail size={16} />}>
              Contact
            </NavButton>
            
            {user ? (
              <UserMenu />
            ) : (
              <Button
                leftSection={<IconLogin size={16} />}
                color="green"
                onClick={() => setLoginModalOpened(true)}
              >
                Login
              </Button>
            )}
          </Group>
        </Group>
      </Container>
      
      <LoginModal 
        opened={loginModalOpened} 
        onClose={() => setLoginModalOpened(false)} 
      />
    </AppShell.Header>
  );
};

export default Navigation;
